import { Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import { observer } from 'mobx-react';
import { sanitizeHtml } from '@roc/ui/utils';
import { ErrorOutline } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: '-26px',
  },
  alert: {
    '& + &': {
      marginTop: theme.spacing(2),
    },
  },
}));

export const NewUiBannerMessages = observer((props) => {
  const classes = useStyles();
  const { messages } = props;
  const { newDesignForSummaryScreen } = props;
  return (
    <>
      {messages?.length > 0 ? (
        <>
          <Box className={newDesignForSummaryScreen ? undefined : classes.container}>
            {messages.map((message, index) => (
              <Alert
                key={index}
                severity="warning"
                icon={newDesignForSummaryScreen ? <ErrorOutline fontSize="inherit" /> : undefined}
                className={classes.alert}
              >
                <AlertTitle>{message.title}</AlertTitle>
                <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(message.content) }}></div>
              </Alert>
            ))}
          </Box>
          <br />
        </>) : <Grid />
      }
    </>
  );
});
